import { Validator } from 'vee-validate'

/**
 * Validate that a field matches a contact number format: mobile or landline with area code.
 */
Validator.extend('contact_number', {
  getMessage: field => `The ${field} field must be a valid mobile number (0412 345 678) or landline with area code (08 8123 4567)`,
  validate: value => /^0[23478]{1}[\d]{8}$/.test(value.replace(/\s/g, ''))
})

const Validation = {
  methods: {
    validate () {
      return this.$validator.validate(...arguments)
        .then((validationResult) => {
          if (!validationResult) {
            return Promise.reject(new Error('Validation has failed.'))
          }

          return Promise.resolve()
        })
    },

    errorClass (field) {
      return { 'has-error': this.errors.has(field) }
    }
  }
}

export default Validation
